import React, { useState } from "react";

export type IBaseMenuProps = {
  handleClose: () => void;
  handleClick: (event: React.MouseEvent<HTMLElement>) => void;
  open: boolean;
  anchorEl: null | HTMLElement;
  id: string;
};

export function useBaseMenuState() {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  return React.useMemo(() => {
    const handleClose = () => {
      setAnchorEl(() => null);
    };

    const handleClick = (e: React.MouseEvent<HTMLElement>) => {
      e.stopPropagation();
      setAnchorEl(() => e.currentTarget);
    };

    return {
      handleClose,
      handleClick,
      open,
      anchorEl,
    };
  }, [anchorEl, open]);
}
